import { Box, Button, Grid, Paper, TextField } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { Autocomplete } from '@material-ui/lab';
import { useFormikContext } from 'formik';
import {
  SearchDictionaryContext,
  SearchDictionaryVariant,
} from 'modules/search/context/dictionary-context';
import SearchRadioGroup from 'modules/search/form-components/search-radio-group';
import { NewCentralFormType } from 'modules/search/types';
import { SearchEntityEnum } from 'modules/search/v3/search-v3-types';
import { getSearchSpaceIntersection } from 'modules/search/v3/search-v3-utils';
import React, { useContext, useMemo } from 'react';

export default function EvidenceUnitsFilter() {
  const { values, setFieldValue } = useFormikContext<NewCentralFormType>();
  const { sources, loading } = useContext(SearchDictionaryContext);
  const label = 'Typy archiválií:';
  const labelExclude = 'Vynechat typy archiválií z vyhledávání';
  const labelInclude = 'Omezit vyhledávání na typy archiválií';
  const placeholder = 'Nyní se vyhledává ve všech typech archiválií';

  const currentList = useMemo(
    () =>
      getSearchSpaceIntersection(
        values.specificFilterRows.map((r) => r.filterOption)
      ),
    [values.specificFilterRows]
  );

  if (!currentList.includes(SearchEntityEnum.EAD_NODE_UNIT)) {
    return null;
  }

  return (
    <Paper style={{ padding: 16 }}>
      <Grid item xs={12}>
        <Box
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          display="flex"
        >
          <SearchRadioGroup
            disabled={loading}
            label={loading ? `${label} (Načítání...)` : label}
            name={`selectedEvidenceUnitTypes.operation`}
            options={[
              { label: labelInclude, value: 'include' },
              { label: labelExclude, value: 'exclude' },
            ]}
          />

          {values.selectedEvidenceUnitTypes.items.length > 0 && (
            <Button
              onClick={() => {
                setFieldValue(`selectedEvidenceUnitTypes.items`, []);
              }}
            >
              <ClearIcon fontSize="small" />
              Zrušit výběr
            </Button>
          )}
        </Box>
        <Autocomplete
          loading={loading}
          disabled={loading}
          autoComplete
          options={
            sources[SearchDictionaryVariant.ARCHIVAL_UNIT_TYPE]?.data ?? []
          }
          getOptionLabel={(option) => option.label}
          defaultValue={[]}
          disableClearable
          multiple
          noOptionsText="Žádné další možnosti"
          filterSelectedOptions
          value={values.selectedEvidenceUnitTypes.items}
          onChange={(e, item) =>
            item && setFieldValue(`selectedEvidenceUnitTypes.items`, [...item])
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={'Přidat / ubrat položky'}
              label={
                loading
                  ? 'Načítávám hodnoty...'
                  : values.selectedEvidenceUnitTypes.items.length === 0
                  ? placeholder
                  : values.selectedEvidenceUnitTypes.operation === 'include'
                  ? labelInclude
                  : labelExclude
              }
              variant="outlined"
              id={`selectedEvidenceUnitTypes.items`}
            />
          )}
        />
      </Grid>
    </Paper>
  );
}
